/*
 * Clair — GA4 blog / outbound click events (program W-G, staged 2026-10-12)
 * --------------------------------------------------------------------------
 * Sends two custom events to the store's EXISTING GA4 tag — the Shopify
 * Google-channel gtag (property G-7B2L1GC4TQ). This file never loads a tag
 * of its own; if window.gtag is absent it silently does nothing.
 *
 *   blog_cta_click  conversion-link clicks: blog-index promo module,
 *                   in-article product / closing modules, the "Where to go
 *                   next" journey module, related-guides / Keep learning
 *                   lists. Params: cta_location, link_url, page_path,
 *                   article_handle (article pages only).
 *   outbound_click  clicks that leave breatheclair.com. Params:
 *                   link_domain, link_url, page_path, article_handle
 *                   (article pages only). Amazon exits are filterable via
 *                   link_domain = "amazon.com".
 *
 * One delegated listener — no per-link markup anywhere, so article bodies
 * (including the D1 pilot pages) stay untouched. Everything is guarded:
 * a tagging error can never break the page.
 */
(function () {
  'use strict';

  var STORE_HOSTS = ['breatheclair.com', 'www.breatheclair.com', 'ai808y-qj.myshopify.com'];
  var CALC_PATH = '/blogs/learn/how-much-does-nasal-rinsing-cost-per-year';
  var HCW_PATH = '/pages/how-clair-works';

  function send(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      }
    } catch (err) { /* tagging must never break the page */ }
  }

  // Lowercased text of the nearest h2/h3 that precedes el in document order.
  function nearestHeadingText(el) {
    try {
      var heads = document.querySelectorAll('h2, h3');
      var text = null;
      for (var i = 0; i < heads.length; i++) {
        // 4 = Node.DOCUMENT_POSITION_FOLLOWING: el comes after this heading
        if (heads[i].compareDocumentPosition(el) & 4) {
          text = (heads[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        }
      }
      return text;
    } catch (err) {
      return null;
    }
  }

  function onClick(ev) {
    try {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
      if (!a) return;

      var raw = a.getAttribute('href');
      if (!raw || raw.charAt(0) === '#') return;

      var url;
      try { url = new URL(raw, window.location.href); } catch (err) { return; }
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;

      var pagePath = window.location.pathname;
      var params = { link_url: url.href, page_path: pagePath };

      var parts = pagePath.split('/').filter(Boolean);
      var onArticle = parts.length === 3 && parts[0] === 'blogs';
      var onBlogIndex = parts.length === 2 && parts[0] === 'blogs';
      if (onArticle) params.article_handle = parts[2];

      var host = url.hostname.toLowerCase();
      var isInternal = STORE_HOSTS.indexOf(host) !== -1;

      if (!isInternal) {
        params.link_domain = host.replace(/^www\./, '');
        send('outbound_click', params);
        return;
      }

      var path = url.pathname;
      var heading = nearestHeadingText(a);
      var ctaLocation = null;

      if (heading === 'where to go next') {
        if (path === CALC_PATH) ctaLocation = 'journey_calculator';
        else if (path === HCW_PATH) ctaLocation = 'journey_how_it_works';
        else if (path.indexOf('/products/') === 0) ctaLocation = 'journey_starter_kit';
        else ctaLocation = 'other_internal_product';
      } else if (heading === 'keep learning' || (heading && heading.indexOf('related guides') === 0)) {
        ctaLocation = 'related_guides';
      } else if (onBlogIndex && (path.indexOf('/products/') === 0 || path === HCW_PATH)) {
        ctaLocation = 'promo';
      } else if (onArticle && path.indexOf('/products/') === 0) {
        ctaLocation = 'article_module';
      } else if (path.indexOf('/products/') === 0) {
        ctaLocation = 'other_internal_product';
      }

      if (ctaLocation) {
        params.cta_location = ctaLocation;
        send('blog_cta_click', params);
      }
    } catch (err) { /* tagging must never break the page */ }
  }

  try {
    document.addEventListener('click', onClick, true);
  } catch (err) { /* no-op */ }
})();
